import React, {useState, useRef, useEffect} from 'react';
import {setVideoPlayerPlaying} from '../actions'
import {useDispatch, useSelector} from 'react-redux'
import ReactPlayer from 'react-player'
//import useInterval from '@use-it/interval';

export default function GenericUrlPlayer({videoRoom, streamSource, ...props}) {

  const dispatch = useDispatch()
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  const videRoomEvent = useSelector(state => videoRoom ? state.events.find(event => event.id == videoRoom.event_id) : null)

  console.error("ONPAUSE DOESNT WORK")
  return (
    <div className='flave-video-container player-wrapper'>
      <style>
        {`
.player-wrapper {
  position: relative;
  padding-top: 56.25% /* Player ratio: 100 / (1280 / 720) */
}

.react-player {
  position: absolute;
  top: 0;
  left: 0;
}
          `}
      </style>
      <ReactPlayer
        width='100%'
        height='100%'
        className='react-player'
        config={ { file: { attributes: { poster: videRoomEvent?.images?.video_player_poster_image?.xl?.url } } } }
        controls
        onPlay={() => {
          if (props.onPlay) {
            props.onPlay()
          }
          if (!videoPlayerPlaying) {
            dispatch(setVideoPlayerPlaying(true))
          }
        }}
        onPause={() => {
          if (videoPlayerPlaying) {
            dispatch(setVideoPlayerPlaying(false))
          }
        }}
        url={streamSource}
      />
    </div>
  )
}

